export const PROJECT_NAME = "auth"

